// ?jail=true or ?jailed=true locks the viewer on one client (embeds, client cockpits): no client
// picker and no admin shortcut out of it; its own reports list stays reachable. A navigation
// convenience, not an access control.
const JAIL_PARAMS = ['jail', 'jailed'];
const OFF_VALUES = ['false', '0'];

/** The jail param of the URL as [name, value], or null when the viewer is free. */
export const jailParam = (searchParams) => {
  for (const name of JAIL_PARAMS) {
    if (!searchParams?.has(name)) continue;
    const value = searchParams.get(name);
    if (!OFF_VALUES.includes(String(value).toLowerCase())) return [name, value || 'true'];
  }
  return null;
};

/** Carries the jail param over to an internal link, so a reload stays jailed. */
export const withJail = (path, jail) => {
  if (!jail) return path;
  const [name, value] = jail;
  return `${path}${path.includes('?') ? '&' : '?'}${name}=${encodeURIComponent(value)}`;
};
